import './App.css';
import { BrowserRouter, Routes , Route} from 'react-router-dom'
import Home from './view/pages/Home';
import Layout from './view/pages/Layout';
import Downloads from './view/pages/Downloads';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<Home />} />
          <Route path='/downloads' element={<Downloads />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
